import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";

// THE ROUTER'S DEFAULT ERROR BOUNDARY. EACH ROUTE CATCHES ITS OWN ERRORS, SO A PAGE
// THAT THROWS RENDERS THIS INSIDE THE SHELL'S OUTLET - THE TOP BAR, MENU AND
// FLOOR-SECTION PROMPT STAY UP - RATHER THAN BLANKING THE WHOLE APP.
export function RouteError({ reset }: ErrorComponentProps) {
  const router = useRouter();
  return (
    <Alert
      severity="error"
      action={
        <Button
          color="inherit"
          onClick={() => {
            reset();
            void router.invalidate();
          }}
        >
          Retry
        </Button>
      }
    >
      <AlertTitle>This page ran into a problem</AlertTitle>
      Something unexpected came back from the server. Retry, or choose another page from the menu.
    </Alert>
  );
}
